module.exports = __webpack_public_path__ + "static/media/ME.ce890864.svg";